import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import {
  ConfigProvider,
  FALLBACK_CONFIG,
  fetchConfig,
  readCachedConfig,
  writeCachedConfig,
} from './config.js';
import { installEventBeacon } from './events.js';
import { noteLegacyIconLaunch } from './push-help.js';
import './theme.css';

// Phase 4 — wire the UX event beacon's tab-close flush listeners once
// at boot. Components track() events directly; this just makes sure
// the queue drains when the tab is hidden or unloaded.
installEventBeacon();
noteLegacyIconLaunch();

// Boot config: prefer the cached blob (instant, persists across reloads),
// fall back to the in-code FALLBACK_CONFIG (always works offline). Always
// kick off a /api/config fetch in the background and update the provider
// once it lands.
function Bootstrap() {
  const [config, setConfig] = useState(() => readCachedConfig() || FALLBACK_CONFIG);

  useEffect(() => {
    let alive = true;
    fetchConfig()
      .then((bundle) => {
        if (!alive || !bundle) return;
        setConfig(bundle);
        writeCachedConfig(bundle);
      })
      .catch((e) =>
        console.warn('[config] fetch failed; using cached/fallback bundle:', e.message)
      );
    return () => {
      alive = false;
    };
  }, []);

  return (
    <ErrorBoundary>
      <ConfigProvider value={config}>
        <App />
      </ConfigProvider>
    </ErrorBoundary>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<Bootstrap />);
